export const MobileProductSection = () => ({
  currentStep: 1,

  goToNextStep(step) {
    this.currentStep = step;
  }
});
